import { Dialog, DialogProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { CloseButton } from '../../buttons';
import { ImageContainer } from '../../imageContainer';

const useStyles = makeStyles({ name: 'MobileImageDialog' })(theme => ({
	paper: {
		width: '100%',
		maxWidth: 'unset',
		height: '100%',
		maxHeight: 'unset',
		margin: 0,
		overflow: 'auto',
		flexDirection: 'column',
		alignItems: 'stretch'
	},
	imageContainer: {
		paddingTop: '88%',
		[theme.originalBreakpoints.up('sm')]: {
			paddingTop: '62%'
		}
	},
	panelContent: {
		boxSizing: 'border-box',
		flexBasis: '50%',
		padding: '30px 45px 45px 45px',
		[theme.originalBreakpoints.up('sm')]: {
			padding: '30px 120px 45px 120px'
		}
	},
	close: {
		position: 'absolute',
		top: 15,
		right: 15,
		[theme.originalBreakpoints.up('sm')]: {
			top: 20,
			right: 20
		}
	}
}));

export type MobileImageDialogClassKey = 'panelContent' | 'buttonClose' | 'imageContainer';
export type MobileImageDialogClasses = { [key in MobileImageDialogClassKey]?: string };
export type MobileImageDialogProps = DialogProps & {
	src: string;
	otherClasses?: MobileImageDialogClasses;
};

export const ImageDialogMobile: React.FC<MobileImageDialogProps> = (props) => {
	const { src, open, onClose, classes, otherClasses, children, ...otherProps } = props;
	const { classes: styles, cx } = useStyles(undefined, { props: { classes: otherClasses } });

	return (
		<Dialog
			open={open}
			onClose={onClose}
			{...otherProps}
			classes={{
				...classes,
				paper: cx(styles.paper, classes?.paper)
			}}>
			<ImageContainer
				src={src}
				className={styles.imageContainer} />
			<div className={styles.panelContent}>
				{children}
			</div>
			<CloseButton
				onClick={() => onClose({}, 'backdropClick')}
				className={styles.close} />
		</Dialog>
	);
};
